import { useEffect } from 'react';

const SEOMeta = ({ title, description, image, url, type = 'website' }) => {
  useEffect(() => {
    const siteUrl = 'https://trueplantvalue.com';
    const defaultImage = `${siteUrl}/og-default.jpg`;
    const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
    const fullImage = image || defaultImage;

    // Title
    document.title = title ? `${title} | True Plant Value` : 'True Plant Value - Real Sold Prices for Rare Houseplants';

    const setMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    // Standard meta
    setMeta('description', description || 'Search real sold prices for rare and common houseplants from actual plant collectors. Free, community-driven plant price database.');
    setMeta('keywords', 'rare houseplant prices, plant sold prices, monstera price, alocasia price, philodendron price, tissue culture plants, rare plant value');
    setMeta('author', 'True Plant Value');

    // Open Graph (Facebook, social sharing)
    setMeta('og:title', title || 'True Plant Value', true);
    setMeta('og:description', description || 'Real sold prices from actual plant collectors.', true);
    setMeta('og:image', fullImage, true);
    setMeta('og:url', fullUrl, true);
    setMeta('og:type', type, true);
    setMeta('og:site_name', 'True Plant Value', true);

    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', title || 'True Plant Value');
    setMeta('twitter:description', description || 'Real sold prices from actual plant collectors.');
    setMeta('twitter:image', fullImage);

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', fullUrl);
  }, [title, description, image, url, type]);

  return null;
};

export default SEOMeta;